import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { springBaseUrl } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/Footer";
import {
  saveCartEarlyCheckin,
  saveEarlyCheckinnSlot,
} from "../redux/slice/slice";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MainSkeleton from "../skeletons/MainSkeleton";
import CheckinSkeleton from "../skeletons/CheckinSkeleton";
import HomeIcon from "@mui/icons-material/Home";
import WorkOffOutlinedIcon from "@mui/icons-material/WorkOffOutlined";

const CancellationStatus = () => {
  const navigate = useNavigate();
  const hotelId = useSelector((state) => state?.HotelId);
  const [loader, setLoader] = useState(false);
  const SummaryData = useSelector((state) => state?.SummaryData);
  const currencySymbol = useSelector((state) => state?.Currency);
  const location = useLocation();

  return (
    <>
      {loader ? (
        <CheckinSkeleton />
      ) : (
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <IconButton
              sx={{ backgroundColor: "#3D3D3D4D" }}
              onClick={() => {
                navigate(`/front-desk-kiosk/${hotelId}`);
                // window.history.back();
              }}
            >
              <HomeIcon
                sx={{ color: "#FFFFFF", fontSize: 24, strokeWidth: 2 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              mt: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box>
              <WorkOffOutlinedIcon sx={{ color: "#FFFFFF", fontSize: 100 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 24, fontWeight: 400 }}>
                Your booking is cancelled
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Card
                sx={{
                  backgroundColor: "#3D3D3D4D",
                  borderRadius: "20px",
                  p: "12px",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    sx={{ fontSize: 16, fontWeight: 400 }}
                    color="text.secondary"
                  >
                    Refund amount
                  </Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
                    {currencySymbol} {location?.state?.cancelCharges?.refundAmt}
                  </Typography>
                </Box>
              </Card>
            </Box>
            {location?.state?.cancelCharges?.refundAmt > 0 && (
              <Box>
                <Typography sx={{ fontSize: 16 }} color="text.gray">
                  Your refunds will be processed in 5-7 business days
                </Typography>
              </Box>
            )}

            {/* Footer with Proceed Button */}
            {/* <Footer>
              <Button fullWidth variant="light-button" onClick={handleProceed}>
                Yes, cancel
              </Button>
            </Footer> */}
          </Box>
        </Box>
      )}
    </>
  );
};

export default CancellationStatus;
